export default __webpack_public_path__ + "static/media/Websites-MitM.54100ae5.png";